var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmileHighIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.14 17.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1abc9c;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Smile-01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.66,10.57a4.12,4.12,0,0,1-1.54,2.18,4.2,4.2,0,0,1-2.55.83A4.2,4.2,0,0,1,6,12.75a4.12,4.12,0,0,1-1.54-2.18.72.72,0,0,1,1-.85.68.68,0,0,1,.35.42,2.85,2.85,0,0,0,5.45,0,.68.68,0,0,1,.36-.42.7.7,0,0,1,.55,0,.68.68,0,0,1,.41.35A.69.69,0,0,1,12.66,10.57ZM7.14,5.72A1.43,1.43,0,1,1,5.71,4.29,1.43,1.43,0,0,1,7.14,5.72Zm5.71,0a1.43,1.43,0,1,1-.42-1A1.43,1.43,0,0,1,12.86,5.72Zm2.86,2.86a6.94,6.94,0,0,0-.57-2.77A7.13,7.13,0,0,0,5.8,2,7.14,7.14,0,0,0,2,11.35a7.13,7.13,0,0,0,9.35,3.8,7,7,0,0,0,3.8-3.8A6.94,6.94,0,0,0,15.71,8.57Zm1.43,0A8.38,8.38,0,0,1,16,12.87,8.53,8.53,0,0,1,12.87,16a8.38,8.38,0,0,1-4.3,1.15A8.38,8.38,0,0,1,4.27,16a8.53,8.53,0,0,1-3.12-3.12A8.38,8.38,0,0,1,0,8.57a8.38,8.38,0,0,1,1.15-4.3A8.53,8.53,0,0,1,4.27,1.15,8.39,8.39,0,0,1,8.57,0a8.38,8.38,0,0,1,4.3,1.15A8.53,8.53,0,0,1,16,4.27,8.39,8.39,0,0,1,17.14,8.57Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileHighIco);
export default __webpack_public_path__ + "static/media/smile-high-ico.88535b1a5dcde80bc88da311a1eb4f8b.svg";
export { ForwardRef as ReactComponent };